import React from 'react';
import { Container, Alert, Typography } from '@mui/material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('🔥 ERROR BOUNDARY 🔥', error, info);
    this.setState({ info });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container sx={{ mt: 5 }}>
          <Alert severity="error">
            <Typography variant="h6">
              Errore frontend non gestito
            </Typography>

            <Typography sx={{ mt: 2 }}>
              {this.state.error?.toString()}
            </Typography>

            <pre style={{ whiteSpace: 'pre-wrap', marginTop: 16 }}>
              {this.state.info?.componentStack}
            </pre>
          </Alert>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
